import type { ThemeColor } from '@/context/ThemeContext';

export const themeColors: ThemeColor[] = [
  { name: 'Green', value: '142 71% 45%', hex: '#22c55e', label: 'Green' },
  { name: 'Rose', value: '347 89% 50%', hex: '#e11d48', label: 'Rose Red' },
  { name: 'Violet', value: '262 83% 58%', hex: '#7c3aed', label: 'Violet' },
  { name: 'Blue', value: '217 91% 60%', hex: '#3b82f6', label: 'Ocean Blue' },
  { name: 'Teal', value: '172 66% 50%', hex: '#14b8a6', label: 'Teal' },
  { name: 'Amber', value: '38 92% 50%', hex: '#f59e0b', label: 'Amber' },
  { name: 'Emerald', value: '142 71% 45%', hex: '#10b981', label: 'Emerald' },
  { name: 'Orange', value: '25 95% 53%', hex: '#f97316', label: 'Orange' },
  { name: 'Slate', value: '215 25% 27%', hex: '#334155', label: 'Slate' },
  { name: 'Crimson', value: '', hex: '#ef4444', label: 'Crimson Red' },
  { name: 'Pink', value: '', hex: '#ec4899', label: 'Pink' },
  { name: 'Fuchsia', value: '', hex: '#d946ef', label: 'Fuchsia' },
  { name: 'Purple', value: '', hex: '#8b5cf6', label: 'Purple' },
  { name: 'Indigo', value: '', hex: '#6366f1', label: 'Indigo' },
  { name: 'Cyan', value: '', hex: '#06b6d4', label: 'Cyan' },
  { name: 'Lime', value: '', hex: '#84cc16', label: 'Lime' },
  { name: 'Yellow', value: '', hex: '#eab308', label: 'Yellow' },
  { name: 'Sky', value: '', hex: '#0ea5e9', label: 'Sky Blue' },
];

export function mapPrimaryColorFromApi(apiValue: string | null | undefined): ThemeColor {
  const v = (apiValue ?? '').trim();
  const presetMatch = themeColors.find(c => c.name.toLowerCase() === v.toLowerCase());
  if (presetMatch) return presetMatch;

  // If backend stores a raw hex (e.g. "#22c55e"), treat it as a custom theme color.
  if (/^#[0-9a-fA-F]{6}$/.test(v)) {
    return { name: 'Custom', value: '', hex: v, label: 'Custom' };
  }

  // Default fallback
  return themeColors.find(c => c.name === 'Green') ?? themeColors[0];
}

